import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Input from './input';
import { INPUT_EVENT_TYPES } from '../constants';
var KEY_EVENTS = INPUT_EVENT_TYPES.KEY_EVENTS;
var DOWN_EVENT_TYPE = 'keydown';
var UP_EVENT_TYPE = 'keyup';

var KeyInput = /*#__PURE__*/function (_Input) {
  _inherits(KeyInput, _Input);

  var _super = _createSuper(KeyInput);

  function KeyInput(element, callback, options) {
    var _this;

    _classCallCheck(this, KeyInput);

    _this = _super.call(this, element, callback, options);

    _this.handleEvent = function (event) {
      // Ignore if focused on text input
      var targetElement = event.target || event.srcElement;

      if (targetElement.tagName === 'INPUT' && targetElement.type === 'text' || targetElement.tagName === 'TEXTAREA') {
        return;
      }

      if (_this.enableDownEvent && event.type === 'keydown') {
        _this.callback({
          type: DOWN_EVENT_TYPE,
          srcEvent: event,
          key: event.key,
          target: event.target
        });
      }

      if (_this.enableUpEvent && event.type === 'keyup') {
        _this.callback({
          type: UP_EVENT_TYPE,
          srcEvent: event,
          key: event.key,
          target: event.target
        });
      }
    };

    _this.enableDownEvent = _this.options.enable;
    _this.enableUpEvent = _this.options.enable;
    _this.events = (_this.options.events || []).concat(KEY_EVENTS);
    element.tabIndex = _this.options.tabIndex || 0;
    element.style.outline = 'none';

    _this.events.forEach(function (event) {
      return element.addEventListener(event, _this.handleEvent);
    });

    return _this;
  }

  _createClass(KeyInput, [{
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      this.events.forEach(function (event) {
        return _this2.element.removeEventListener(event, _this2.handleEvent);
      });
    }
    /**
     * Enable this input (begin processing events)
     * if the specified event type is among those handled by this input.
     */

  }, {
    key: "enableEventType",
    value: function enableEventType(eventType, enabled) {
      if (eventType === DOWN_EVENT_TYPE) {
        this.enableDownEvent = enabled;
      }

      if (eventType === UP_EVENT_TYPE) {
        this.enableUpEvent = enabled;
      }
    }
  }]);

  return KeyInput;
}(Input);

export { KeyInput as default };